import React from "react";
import { Instagram, Facebook, Star } from "lucide-react";
import { businessInfo } from "../data/mock";
import "../styles/Footer.css";

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const openGoogleReviews = () => {
    window.open("https://share.google/SndUyIeDae1IEfzXT", "_blank");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/5wpjtg46_Aura_Clean-removebg-preview.png" 
                alt="Aura Aesthetics Academy Logo" 
                className="footer-logo-image"
              />
            </div>
            <p className="body-regular footer-tagline">
              Revitalize your beauty with aesthetic IV infusions
            </p>
            <div className="footer-social">
              <a
                href={`https://instagram.com/${businessInfo.social.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={`https://tiktok.com/@${businessInfo.social.tiktok.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="TikTok"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a
                href={`https://facebook.com/${businessInfo.social.facebook.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <button
                onClick={openGoogleReviews}
                className="social-link google-reviews-link"
                aria-label="Google Reviews"
              >
                <Star size={20} />
              </button>
            </div>
            <button onClick={openGoogleReviews} className="google-reviews-text">
              <Star size={14} fill="var(--gold-primary)" color="var(--gold-primary)" />
              <span>Leave us a Google Review</span>
            </button>
          </div>

          <div className="footer-section">
            <h4 className="body-regular footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <button onClick={() => scrollToSection("about")} className="footer-link">
                About
              </button>
              <button onClick={() => scrollToSection("services")} className="footer-link">
                Services
              </button>
              <button onClick={() => scrollToSection("testimonials")} className="footer-link">
                Testimonials
              </button>
              <button onClick={() => scrollToSection("faq")} className="footer-link">
                FAQ
              </button>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="body-regular footer-heading">Contact</h4>
            <div className="footer-contact">
              <a href={`tel:${businessInfo.phone}`} className="footer-link">
                {businessInfo.phone}
              </a>
              <a href={`mailto:${businessInfo.email}`} className="footer-link">
                {businessInfo.email}
              </a>
              <p className="body-small footer-address">{businessInfo.address}</p>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="body-regular footer-heading">Opening Hours</h4>
            <div className="footer-hours">
              <p className="body-small">{businessInfo.hours.weekday}</p>
              <p className="body-small">{businessInfo.hours.saturday}</p>
              <p className="body-small">{businessInfo.hours.sunday}</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {new Date().getFullYear()} Aura Aesthetics Academy. All rights reserved.
          </p>
          <p className="body-small">
            20+ years of medical expertise in aesthetic treatments
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
